import React,{useCallback,useRef,useState,useContext} from "react";
import { Icon, Label, Pivot, PivotItem } from "@fluentui/react";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { tabDetails } from "../../helpers/initData";
import themeContext from "../../../../context/theme/ThemeContext";
import userContext from "../../../../context/users/UserContext";

const MobileStudylistTabBar = () => {

    const {
        roles,
        selectedValue,
        setSelectedValue,
        handleCXRTabChange,
        unreportedAllTabs,
        peerReviewAssignedTab,
        archivedStudyRequestTab,
        savedAllTabs,
        sortGlobal,
        setSortGlobal
      } = useContext(studylistContext);
      const {contextSwitchUser,qcReviewer, peerReviewAdmin, peerReviewEvaluator} = useContext(userContext);

      const { themeName } = useContext(themeContext);


      const handleMobileTabChange = (key) => {

        if(key == "study_3" && sortGlobal.sortColumn === "assignment_created_date" && sortGlobal.sortOrder === "desc"){
            setSortGlobal(() => {
              const newItem = { ...sortGlobal };
              newItem.sortColumn = "report_submitted_date";
              newItem.sortOrder = "desc";
              return newItem;
            });
          }else if((sortGlobal.sortColumn === "report_submitted_date")){
            setSortGlobal(() => {
              const newItem = { ...sortGlobal };
              newItem.sortColumn = "assignment_created_date";
              newItem.sortOrder = "desc";
              return newItem;
            });
          }

        setSelectedValue(key);
      }

    return (
         
         <div style={{ width:'calc(100% - 22px)' }}>
            <Pivot  className="xray-tabs-pivot"
                aria-label="Xray tabs"
                linkSize="small"
                onLinkClick={(item) => {handleMobileTabChange(item.props.itemKey)}}
                overflowBehavior={ 'menu'}
                overflowAriaLabel="more items"
                >
                {tabDetails(roles, selectedValue,themeName, unreportedAllTabs, peerReviewAssignedTab, contextSwitchUser, qcReviewer, peerReviewAdmin, peerReviewEvaluator, archivedStudyRequestTab, savedAllTabs).map((tabElement, index)=>{
                    return tabElement.show && <PivotItem key={index} headerText={tabElement.title} itemKey={tabElement.id}></PivotItem>
                })}
                </Pivot>

      
    
    </div>)
}

export default MobileStudylistTabBar;

